import { gql } from "@apollo/client";
import Uid2Token from "@/lib/uid2Token";

export const typeDef = gql`
  type HowtoPlay @cacheControl(maxAge: 60) {
    id: ID!
    free: Boolean
    member_only: Boolean
    rights: [Right]
    courses: [Course]
    products: [Product]
  }

  type Uid2Token {
    token: String
  }

  type Query {
    howtoPlay(id: Int): HowtoPlay
    uid2Token: Uid2Token
  }
`;

export const resolvers = {
  Query: {
    howtoPlay: async (_parent, { id }, { dataSources }) => {
      try {
        // 権利がたくさん紐づいているチャンネルのIDを指定されるとAPI側が落ちるのでエピソードかどうか確認する
        const res = await dataSources.episodes.getEpisode(id);
        const meta = res.metas[0];
        if (!meta) {
          throw new Error(`not episode meta. ID: ${id}`);
        }
        const howtoplay = await dataSources.meta.howtoPlay(id);
        const courses = howtoplay.courses;
        const rightIds = [];
        courses?.forEach((e) => {
          const value = e?.ref_id;
          if (value) {
            rightIds.push(`ref:${value}`);
          }
        });
        return { id, ...howtoplay };
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    uid2Token: async (_parent, _args, { req, res }) => {
      const uid2 = new Uid2Token(req, res);
      try {
        const token = await uid2.getToken();
        return { token };
      } catch (e) {
        console.log(e);
        return null;
      }
    },
  },
};
